import photo1 from './project24-1.png';
import photo2 from './project24-2.png';
import photo3 from './project24-3.png';
import photo4 from './project24-4.png';
import photo5 from './project24-5.png';
import photo6 from './project24-6.png';
import photo7 from './project24-7.png';
import photo8 from './project24-8.png';
import photo9 from './project24-9.png';
import photo10 from './project24-10.png';

const project24 = {
  id: 24,
  name: 'Qrumble (큐럼블)',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '김윤지, 이아영, 최서윤',
    },
    {
      position: 'BackEnd Developer',
      names: '김은솜, 소현아, 오민지, 육란',
    },
    {
      position: 'UXUI Designer',
      names: '황유민',
    },
  ],
    about:
    "매일 제공되는 질문에 대한 나의 생각을 영어로 답하고, 나만의 쿠키를 완성하자!\n" +
    "영어로 글을 쓰며 공부하고 싶어도 막상 시작하기 어렵고, 꾸준히 이어가기 힘든 분들이 많습니다. Qrumble은 매일 간단한 질문으로 자연스럽게 영어 글쓰기에 참여할 수 있도록 돕는 서비스입니다. 부담 없이 짧은 글을 쓰며 꾸준한 학습 습관을 만들고, 다양한 표현과 피드백을 통해 영어 표현력을 조금씩 확장해 나갈 수 있습니다.\n" +
    "Qrumble은 일상 속에서 영어 학습을 자연스럽게 이어가고 싶은 분들을 위해 개발되었습니다.",  
    inks: {
        // website: '',
        // github: '',
  },
  photos: [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8, photo9, photo10],
};

export default project24;
